export const directors = [
  {
    id: "european-auteur",
    name: "欧洲作者导演",
    region: "法国 / 意大利 / 北欧",
    style: "以作者论为核心，节奏缓慢、留白多，重视情绪与氛围甚于情节。常把伦理议题放进冷静的镜头里，让观众自己完成判断。",
    works: "《戏梦巴黎》《破浪》《她》等导演的持续探索",
  },
  {
    id: "american-indie",
    name: "美国独立电影",
    region: "美国",
    style: "关注中产与郊区生活，用自然主义的对白和克制的表演呈现关系危机。相较欧洲同行更贴近叙事的连贯与情感的推进。",
    works: "《性、谎言和录像带》《蓝色情人节》等",
  },
  {
    id: "british-drama",
    name: "英国剧情传统",
    region: "英国",
    style: "继承了强烈的文本与舞台感，重视阶级与体面。对白锋利，冲突多发生在客厅与餐桌，情绪藏在礼貌之下。",
    works: "《革命之路》式的客厅戏剧传统",
  },
  {
    id: "cold-north",
    name: "北欧冷峻派",
    region: "丹麦 / 瑞典 / 挪威",
    style: "影像克制、色调清冷，偏爱围观普通人在制度与孤独中的挣扎。代表人物推动了「教条式」极简拍摄理念。",
    works: "Dogme 95 及其后继者的创作",
  },
];